import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSoundAction, playSoundAction, clearSoundAction } from "../../../../../redux/sound";

const AnsweringCompletePopup = () => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setSound = payload => { dispatch( setSoundAction( payload ) ) };
  const playSound = () => { dispatch( playSoundAction() ) };
  const clearSound = () => { dispatch( clearSoundAction() ) };

  useEffect( () => {
    setSound( { src : `${ process.env.PUBLIC_URL }/static/audio/lc_05_06.ogg` } );
    playSound();
    return () => {
      setTimeout( clearSound );
    };
  }, [] );

  return (
    <div className="lp-wrap lp-middle nothead gb">
      <div className="lp-container lc-alert type2 h_auto">
        <p className="lc-alert_txt fwm" dangerouslySetInnerHTML={ { __html : answeringQuestions.resultData.aiMsge } } />
        <div className="lc-alert_aniBtm bg_finish" />
      </div>
    </div>
  );

};

export default AnsweringCompletePopup;
